// ---------------------------------------------------------------------------
// Logos slider
// ---------------------------------------------------------------------------
import Splide from '@splidejs/splide';

export function initLogosSlider() {
    const el = document.querySelector('[data-logos-slider]');
    if (!el) return;

    new Splide(el, {
        type: 'loop',
        perPage: 6,
        perMove: 1,
        gap: 30,
        arrows: false,
        pagination: false,
        autoplay: true,
        interval: 2500,
        speed: 650,
        pauseOnHover: true,
        pauseOnFocus: true,
        drag: true,
        breakpoints: {
            1200: {
                perPage: 5,
                gap: 25,
            },
            900: {
                perPage: 4,
                gap: 25,
            },
            765: {
                perPage: 3,
                gap: 20,
            },
            425: {
                perPage: 2,
                gap: 20,
            },
        },
    }).mount();
}